import { BannerCarousel, CommonSelect, CstmPagination } from 'components/Common/Common'
import ErrorComponent from 'components/shared/ErrorComponent'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayoutV2 from 'components/TableLayoutV2'
import { GRADE_OPTIONS } from 'config/constants'
import { TASK_PLANS_LIST } from 'config/paths'
import { dateFormat, userFullName } from 'helpers/common'
import { debounce } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router-dom'
import { useGetSupportStaffListQuery } from 'store/services/SupportStaff'
import { supportStaffFilter } from 'store/slices/filter'


function SupportStaff() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filter = useSelector(state => state?.filter?.supportStaffFilter);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const { data: supportStaffList, isLoading, isError, isFetching } = useGetSupportStaffListQuery({ page: currentPage, limit: pageSize, ...filter })
  const totalRecords = supportStaffList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);


  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };


  const handleFilterChange = (key) => (value) => {
    dispatch(supportStaffFilter({ ...filter, [key]: value }))
    setCurrentPage(1);
  };

  const column = [
    // {
    //   head: <div onClick={() => dispatch(supportStaffFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
    //   accessor: "is_favorite",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
    //       <div className="cursor-pointer" onClick={(e) => {
    //         e.stopPropagation();
    //         handleFavouriteReport(item?.assesmentResources?.id, item?.is_favorite ? 0 : 1)
    //       }}>
    //         {item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}
    //       </div>
    //     </h6>
    //   ),
    // },
    {
      head: "FIRST NAME",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.firstname}
          </h6>
        )
      },
    },
    {
      head: "LAST NAME",
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.lastname}
          </h6>
        )
      },
    },
    {
      head: "GRADES",
      accessor: "client_grade",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.grades?.length > 0 ? item?.grades?.map((item) => item).join(", ") : "--"}
          </h6>
        )
      }
    },
    {
      isComponent: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 style={{ fontStyle: 'italic' }} className="m-0 text-capitalize d-flex align-items-center gap-2">
            {`${item?.total_clients} Clients`}
          </h6>
        )
      }
    },
    {
      isComponent: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 style={{ fontStyle: 'italic' }} className="m-0 text-capitalize d-flex align-items-center gap-2">
            {`${item?.total_tasks} Tasks`}
          </h6>
        )
      }
    },
  ];

  const handleSearchChange = useCallback(debounce((value) => {
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  return (
    <>
      <section className='client position-relative py-4 px-2 min-vh-100' style={{ background: "#3DA0AA0D" }}>
        <Container fluid>
          {(isLoading) ? (
            <div style={{ height: "200px" }}>
              <LoadingIndicator />
            </div>
          ) : (
            <Col className='col-lg-10'>
              {/* <CaseloadSchool caseloadData={caseloadSchoolData?.record} /> */}
              <div style={{ justifyContent: 'space-between' }} className='left classroom-conslutation d-flex justify-content-between align-items-end mt-4'>
                <h6 className="m-0 fw-bold main-head">Support Staff</h6>
                <Col lg="6">
                  <Row>
                    <Col xs="6" md='5'>
                      <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                        <label className="discharge-screen-label mb-0 ">GRADE</label>
                        <CommonSelect
                          placeholder={"Select"}
                          option={GRADE_OPTIONS}
                          onChange={(e) => handleFilterChange("grade")(e)}
                          value={filter?.grade}
                          isFilterV2
                          isClearable
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "100%",
                            }),
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs="6" md='6'>
                      <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                        {/* <label className="discharge-screen-label mb-0">DISCIPLINE</label> */}
                        {/* <CommonSelect
                          placeholder={"Select"}
                          option={disciplines}
                          onChange={(e) => handleFilterChange("discipline")(e)}
                          value={filter?.discipline}
                          isFilterV2
                          isClearable
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "100%",
                            }),
                          }}
                        /> */}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs="4" md='4'>
                  <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0 text-end">SEARCH</label>
                    <input
                      type="text"
                      style={{ borderRadius: "8px", height: "30px" }}
                      placeholder='Type to search...'
                      className="read-only form-control w-100"
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />
                  </div>
                </Col>
              </div>

              <div className="table-outer mt-3">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={supportStaffList?.records || []}
                      column={column}
                      filter={filter}
                      handleRowClick={(row) => {
                        navigate(generatePath(TASK_PLANS_LIST, { id: row?.id }))
                      }}
                      handleSort={handleFilterChange("sort")}
                    // handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          )}
        </Container>
      </section>
    </>
  )
}

export default SupportStaff
